/*
**************************** 
홈페이지 공지사항 페이징
*****************************
*/

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/Pagination.scss";

export default function Pagination(props) {
    const navigate = useNavigate();

    const [pagin, setPagin] = useState([]);

    const pageinBar = function (_props) {
        const page = _props.page;
        const totalCount = _props.count;

        var pageno = page;
        if (pageno < 1) {
            pageno = 1;
        }

        var total_record = totalCount;
        var page_per_record_cnt = 10;
        var group_per_page_cnt = 5;

        var total_page = Math.ceil(total_record / page_per_record_cnt);

        if (pageno > total_page) {
            pageno = total_page;
        }

        var group_no = Math.ceil(pageno / group_per_page_cnt);

        var page_eno = group_no * group_per_page_cnt;
        var page_sno = page_eno - (group_per_page_cnt - 1);

        if (page_eno > total_page) {
            page_eno = total_page;
        }

        var prev_pageno = page_sno - group_per_page_cnt;
        var next_pageno = page_sno + group_per_page_cnt;
        if (prev_pageno < 1) {
            prev_pageno = 1;
        }
        if (next_pageno > total_page) {

            next_pageno = total_page;
        }

        let copyPgin = [...pagin];
        copyPgin = [];
        for (var i = page_sno; i <= page_eno; i++) {
            const uris = "/community/notice/" + i;
            copyPgin[i - 1] = uris;
        }

        setPagin(copyPgin);
    }

    useEffect(() => {
        pageinBar(props);
    }, [props]);

    return (
        <div className="container">
            <div className="paginotice" >
                <div className="pagination">
                    {props.page > 5 ? <a href="#" onClick={() => {
                        const pageIdx = 1;
                        const uris = "/community/notice/" + pageIdx + "/list";
                        navigate(uris);
                    }}>&lt;&lt;</a> : null}
                    {props.page > 5 ? <a href="#" onClick={() => {
                        const pageIdx = Number(props.page) - 1;
                        const uris = "/community/notice/" + pageIdx + "/list";
                        navigate(uris);
                    }}>&lt;</a> : null}
                    {pagin.map((cell, idx) => {
                        const pageIdx = idx + 1;
                        const uris = "/community/notice/" + pageIdx + "/list";
                        return (
                            <Link key={pageIdx} to={uris} className={props.page == pageIdx ? "active" : null}>{pageIdx}</Link>
                        )
                    })}
                    {props.count > (props.page * 10) ? <a className="" href="#" onClick={() => {
                        const pageIdx = Number(props.page) + 1;
                        const uris = "/community/notice/" + pageIdx + "/list";
                        navigate(uris);
                    }}>&gt;</a> : null}
                    {props.count > (props.page * 10) ? <a className="" href="#" onClick={() => {
                        const pageIdx = Math.ceil(props.count / 10);
                        const uris = "/community/notice/" + pageIdx + "/list";
                        navigate(uris);
                    }}>&gt;&gt;</a> : null}
                </div>
            </div>
        </div>
    )
}